import { useRecoilState, useRecoilValue } from "recoil";
import { Document, Page } from "react-pdf";
import mkmetalpdf from "../pogopin_thumnail.pdf";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import {
  mobileCurrentPage,
  mobileInputPage,
  pageState,
  pdfPage,
  pdfRef,
} from "../atoms";
import { useMediaQuery } from "@mui/material";

const StyledDocument = styled(Document)`
  display: flex;
  overflow-x: auto;
  align-items: center;
  justify-content: ${(props) => (props.$isMobile ? " " : "center")};
  width: 100%;
  background-color: #f3f5f6;
`;

const ThumnailBox = styled.div`
  border: ${(props) =>
    props.$isClick ? "1.5px solid #014EA2" : "1px solid #ddd"};
  border-radius: 4px;
  padding: 5px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
`;

function ThumnailViewer() {
  const [bookRef, setBookRef] = useRecoilState(pdfRef);
  const [pageStates, setPageState] = useRecoilState(pageState);
  const [numPages, setNumPages] = useRecoilState(pdfPage);
  const isMobile = useMediaQuery("(max-width: 1190px)");
  const thumbnailRefs = useRef([]); // 썸네일 ref 배열
  const [currentPage, setCurrenPage] = useRecoilState(mobileCurrentPage);
  const [inputValue, setInputValue] = useRecoilState(mobileInputPage);

  const pageNumber = pageStates.currentPage;

  useEffect(() => {
    // 페이지가 변경되면 해당 썸네일이 화면에 보이지 않으면 스크롤 이동
    if (thumbnailRefs.current[pageNumber - 1]) {
      thumbnailRefs.current[pageNumber - 1].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [pageNumber]);

  useEffect(() => {
    if (thumbnailRefs.current[currentPage - 1]) {
      thumbnailRefs.current[currentPage - 1].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [currentPage]);

  const goToThumnailPage = (index) => {
    if (window.innerWidth < 768) {
      setCurrenPage(index + 1);
      setInputValue(index + 1);
    } else {
      bookRef.pageFlip().flip(index);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        position: "fixed",
        bottom: "60px",
      }}
    >
      <StyledDocument file={mkmetalpdf} $isMobile={isMobile}>
        {Array.from(new Array(numPages), (_, index) => (
          <ThumnailBox
            key={`thumbnail-${index}`}
            onClick={() => goToThumnailPage(index)}
            $isClick={
              window.innerWidth < 768
                ? currentPage === index + 1
                : window.innerWidth < 1190
                ? pageNumber === index + 1
                : pageNumber === index + 1 || pageNumber === index
            }
            ref={(el) => (thumbnailRefs.current[index] = el)}
          >
            <Page
              pageNumber={index + 1}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              scale={isMobile ? 0.09 : 0.09} // 썸네일 크기 조정 (작게 보이도록 설정)
            />
            <p
              style={{ marginTop: "5px", fontSize: isMobile ? "12px" : "12px" }}
            >
              {index + 1}
            </p>
          </ThumnailBox>
        ))}
      </StyledDocument>
    </div>
  );
}

export default ThumnailViewer;
